import React from 'react'
import * as Displays from 'support/displays'
import { ReadOnlyModel } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'

function Weather (props) {
  const { date } = props

  return (
    <ReadOnlyModel resourceName='shifts.schedule' operationName='fetch'>
      <div style={{float: "right", marginTop: -20}}>
        <Displays.Image name={['weather', date, 'symbol_url'].join('.')} width={45}/>
      </div>
      <div className={"relative"}>
        <div style={{float: "left"}}>
          <span className={props.stringClasses}>
            <Displays.Number name={['weather', date, 'temperature'].join('.')} maxDecimals={0} minDecimals={0} />°C
            / <Displays.Number
              name={['weather', date, 'precipitation'].join('.')} maxDecimals={0}
              minDecimals={0}
              /> mm
          </span>
        </div>
      </div>

    </ReadOnlyModel>
  )
}

Weather.defaultProps = {
  stringClasses: 'text-gray-400 text-xs mt-1',
  linkClasses: 'block absolute bottom-0 right-0'
}

Weather.propTypes = {
  date: PropTypes.string.isRequired
}

export default Weather
